import { embroideriesDispatcher, useEmbroideryContent } from 'src/features/brands/hooks/useEmbroideryContent'
import { Embroidery, EmbroideryKey, I18NText, PartialActionDispatch, StateObj } from 'src/types'
import { isHalfWidthCharChecker } from 'src/features/brands/hooks/embroiderySetting'

export const characterCheckHelper = (embroidery: Embroidery, productNumber: string, t: I18NText) => {
  const { content, position } = embroidery
  const isHalfWidthChar = isHalfWidthCharChecker(content)
  const isJapanese = content.charCodeAt(0) >= 256
  const isKoreaContents = content.charCodeAt(0) >= 40001
  const typeFaceObjs = t.EMBROIDERY_TYPEFACE_OBJECTS
  const typeFaceJaObjs = typeFaceObjs.filter((t) => ['serif'].includes(t.value))
  const typeFaceEnObjs = typeFaceObjs.filter((t) => ['sans-serif', 'Brush Script MT', 'cursive'].includes(t.value))
  const typeFaceObjects = isJapanese ? typeFaceJaObjs : typeFaceEnObjs
  const isThumbPosition = position.value === 'thumbFinger'
  const mustExpandCharSize = isThumbPosition
  const halfWidthChar = mustExpandCharSize ? 20 : 12
  const fullWidthChar = mustExpandCharSize ? 10 : 6

  return {
    contentMaxLength: isHalfWidthChar ? halfWidthChar : fullWidthChar,
    existsContent: content.length > 0,
    typeFaceObjects,
    isKoreaContents,
    contentCaution: isKoreaContents ? '한자,영어만 자수가능합니다. 한글은 자수 불가입니다.' : ''
  }
}

export const positionObjectGenerator = (productNumber: string, isFirst: boolean, t: I18NText): StateObj[] => {
  const isErmCatcherMitt = productNumber === 'APL-UR002+'
  const position1 = isErmCatcherMitt ? t.EMBROIDERY_POSITION_OBJECTS.filter((p) => p.value !== 'thumbFinger') : t.EMBROIDERY_POSITION_OBJECTS
  const position2 = isFirst ? position1.filter((p) => p.value !== 'childFinger') : position1.filter((p) => p.value !== 'pinkyFingerSideBack')
  return position2
}

export const useAtomsEmbroideriesDispatchGenerator = (dispatch: PartialActionDispatch, embroideries: Embroidery[], t: I18NText) => {
  const atomsEmbroideriesDispatcher = (key: EmbroideryKey) => {
    const atomsObjects = {
      position: t.EMBROIDERY_POSITION_OBJECTS,
      typeFace: t.EMBROIDERY_TYPEFACE_OBJECTS,
      color: t.EMBROIDERY_COLOR_OBJECTS,
      shadowColor: t.EMBROIDERY_SHADOW_EDGE_COLOR_OBJECTS,
      edgeColor: t.EMBROIDERY_SHADOW_EDGE_COLOR_OBJECTS
    }
    return (selected: string, i?: number) => embroideriesDispatcher(dispatch, embroideries, selected, atomsObjects, key, i)
  }
  const handleContentAndNum = useEmbroideryContent(dispatch, embroideries)
  return {
    handle: {
      typeFace: atomsEmbroideriesDispatcher('typeFace'),
      position: atomsEmbroideriesDispatcher('position'),
      color: atomsEmbroideriesDispatcher('color'),
      shadowColor: atomsEmbroideriesDispatcher('shadowColor'),
      edgeColor: atomsEmbroideriesDispatcher('edgeColor'),
      content: (selected: string, i?: number) => {
        if (i === undefined) return
        handleContentAndNum(selected, i)
      }
    }
  }
}

export const cautionGenerator = (
  condition: boolean,
  key: 'position' | 'typeFace' | 'contents' | 'shadowColor' | 'edgeColor',
  t: I18NText
): string => {
  if (condition) {
    switch (key) {
      case 'position':
        return t.CAUTION_EMBROIDERY_POSITION
      case 'contents':
        return t.CAUTION_EMBROIDERY_CONTENTS
      case 'typeFace':
        return t.CAUTION_EMBROIDERY_TYPEFACE
      case 'shadowColor':
      case 'edgeColor':
        return t.CAUTION_EMBROIDERY_SHADOW_EDGE_COLOR
    }
  } else {
    return ''
  }
}

export const generateSubColors = (shouldFiltering: boolean, colors: StateObj[]) => {
  return shouldFiltering ? colors.filter((o) => o.value === 'none') : colors
}
